import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import HoveredButton from 'emergency_data/src/components/HoveredButton';
import {
  CopyRowBox,
  LeftText,
  MiddleText,
  RowBox,
  IconWrapper,
} from 'emergency_data/src/components/Location/styles/common.styles';
import { LatLongIcon } from '@rsos/assets/icons';
import copyToClipboard from '@rsos/utils/copyToClipboard';
import { trackCopyAlertLocation } from './alertLocationTrackings';

const LatLong = ({ longitude, latitude, isHoverable }) => {
  const [isCopied, setIsCopied] = useState();
  const selectedAlertID = useSelector(state => state.incidents.selectedAlertID);
  const irpVersion = useSelector(state => state.sinatra.irp.irpVersion);

  const onClick = () => {
    setIsCopied(true);
    copyToClipboard(`${latitude}, ${longitude}`);
    trackCopyAlertLocation(selectedAlertID, irpVersion);
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  let latLong = null;
  if (parseFloat(latitude) && parseFloat(longitude)) {
    latLong = `
      ${parseFloat(latitude).toFixed(5)}, ${parseFloat(longitude).toFixed(5)}
    `;
  }

  return (
    <RowBox isHoverable={isHoverable} copied={isCopied}>
      <RowBox>
        <RowBox pr={2}>
          <IconWrapper>
            <LatLongIcon />
          </IconWrapper>
        </RowBox>
        <CopyRowBox data-name="location-lat-long">
          <LeftText>Lat/Long:&nbsp;</LeftText>
          <MiddleText data-name="location-lat-long-text">{latLong}</MiddleText>
        </CopyRowBox>
      </RowBox>
      {isHoverable && (
        <HoveredButton onClick={onClick} withIcon isCopied={isCopied} />
      )}
    </RowBox>
  );
};

export default LatLong;
